import { ReactNode, useEffect, useState } from 'react';
import { cn } from '@anytag/shared-utils';
import { Option } from '@anytag/shared-types';
import { ModalTitle } from '@anytag/shared-atoms';
import { usePostModalContext } from '../post-modal-context';

export interface TabsProps<V> {
  defaultTab?: V;
  className?: string;
  tabs: Option<V, ReactNode>[];
  onChange?: (selectedTab: V) => void;
  children: (props: { selectedTab: V }) => ReactNode;
}
export const Tabs = <V,>({ className, tabs, children, onChange, defaultTab }: TabsProps<V>) => {
  const { selectedPostId } = usePostModalContext();
  const [selectedTab, setSelectedTab] = useState<V>(defaultTab || (tabs.at(0)?.value as V));

  useEffect(() => {
    if (selectedPostId) {
      setSelectedTab(defaultTab || (tabs.at(0)?.value as V));
    }
  }, [selectedPostId]);

  return tabs.length > 1 && !!selectedTab ? (
    <>
      <ModalTitle className={cn('flex custom-scrollbar gap-4 overflow-x-auto', className)}>
        {tabs.map((tab, index) => (
          <div
            key={index}
            className={cn(
              'box-border flex min-w-15 flex-none cursor-pointer items-center justify-center border-b-3 border-b-transparent px-2 pb-1 text-center text-md text-black-60',
              { 'border-b-blue-70 font-semibold text-black-90': selectedTab === tab.value }
            )}
            onClick={() => {
              setSelectedTab(tab.value);
              onChange?.(tab.value);
            }}
          >
            {tab.label}
          </div>
        ))}
      </ModalTitle>

      {children({ selectedTab })}
    </>
  ) : (
    children({ selectedTab })
  );
};
